module.exports = __webpack_public_path__ + "static/img/破了吗8.61ce37d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/破了吗8.jpg
// module id = Bhm7
// module chunks = 73